/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_median.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts a multivalued field into a single valued field containing the median value.',
  examples: [
    'ROW a=[3, 5, 1]\n| EVAL median_a = MV_MEDIAN(a)',
    'ROW a=[3, 7, 1, 6]\n| EVAL median_a = MV_MEDIAN(a)',
  ],
  params: {
    number: 'Expression that can be null, a single value, or multiple values.',
  },
};

export default docs;
